import React from 'react';

export default class UsingMenu extends React.Component {
  render() {
    return <div className="content">
      <h1 className="title is-3">Using the Menu of Resonable Choice</h1>
      <ul>
        <li><b>Formulate</b> a Menu of Reasonable Choices.</li>
        <li><b>Educate</b> the patient as to the benefits and adverse effects of each option.</li>
        <li><b>Encourage</b> the patient to select an intervention based on their preference.</li>
      </ul>
      <img src="/assets/images/menuofreasonablechoices.jpeg" />
      <p><b>The Menu of Reasonable choices</b> will be revised for each individual based on their measured outcomes and any new treatment information that may become available.  The process of applying this accumulated knowledge gradually optimizes the treatment plan. </p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/more/UsingMenu.js